import React from 'react';
import { compose } from 'redux';
import { connectMediaStore } from '../../../_hocs/withOwnReduxStore';
import { withTranslation, WithTranslation } from 'react-i18next';
import DeviationGrid from '../../DeviationGrid';
import PopupInnerLayout from '../../../_partials/PopupInnerLayout';
import { PapiDeviation } from '@wix/da-papi-types';
import {
  moveDeviationToPosition,
  MoveDeviationToPositionPayload,
  removeDeviations,
  RemoveDeviationsPayload,
} from '../../../actions';
import withCustomSetDeviations, {
  WithCustomSetDeviationsProps,
} from '../../../_hocs/withCustomSetDeviations';
import withSelectedDeviations, {
  WithSelectedDeviationsProps,
} from '../../../_hocs/withSelectedDeviations';
import AddDeviationsButton from '../../../_partials/AddDeviationsButton';
import GroupOperationButton from '../../../_partials/GroupOperationButton';
import ManageableDeviation from '../../../_partials/ManageableDeviation';
import SelectedItemsPanel from '../../../_partials/SelectedItemsPanel';

import customSetDeviationManagerStyles from './CustomSetDeviationManager.scss';

export interface Props {
  sideBarContent?: React.ReactNode;
}

const enhance = compose(
  withCustomSetDeviations,
  withSelectedDeviations,
  connectMediaStore(null, {
    moveDeviationToPosition,
    removeDeviations,
  }) as any,
  withTranslation()
);
export class CustomSetDeviationManager extends React.Component<
  Props &
    WithCustomSetDeviationsProps &
    WithSelectedDeviationsProps &
    WithTranslation & {
      moveDeviationToPosition(payload: MoveDeviationToPositionPayload): void;
      removeDeviations(payload: RemoveDeviationsPayload): void;
    },
  { showMediaSelector: boolean }
> {
  render() {
    const { sideBarContent, t } = this.props;

    return (
      <>
        <PopupInnerLayout
          oneRowHeader
          headerSubtitle={t('mediapopup.editYourDeviationSetHint')}
          headerExtrasRightZone={
            <AddDeviationsButton
              limit={this.getSelectionLimitRemaining()}
              disabled={!this.getCanAddMore()}
            />
          }
          headerExtrasBottomZone={
            <SelectedItemsPanel
              extrasClassName={
                customSetDeviationManagerStyles['selected-items-extras']
              }
              extras={this.renderSelectedItemsPanelExtras()}
              showSelectionLimit={false}
            />
          }
          scrollableContent={this.renderContent()}
          sideBarContent={sideBarContent}
        />
      </>
    );
  }

  onDeleteSelected = () => {
    this.props.selectedDeviations &&
      this.props.removeDeviations(this.props.selectedDeviations);
  };

  renderSelectedItemsPanelExtras() {
    return (
      <GroupOperationButton onClick={this.onDeleteSelected}>
        {this.props.t('mediapopup.itemMenu.delete')}
      </GroupOperationButton>
    );
  }

  // Can we add more deviations to the set without breaking the selectionLimit?
  getCanAddMore() {
    const selectionLimitRemaining = this.getSelectionLimitRemaining();
    return selectionLimitRemaining === undefined
      ? true
      : selectionLimitRemaining > 0;
  }

  // How many deviations can we add to the set?
  getSelectionLimitRemaining() {
    const { selectionLimit, deviations } = this.props;
    return selectionLimit ? selectionLimit - deviations.length : selectionLimit;
  }

  renderContent() {
    const { deviations } = this.props;
    return (
      <DeviationGrid
        deviations={deviations}
        deviationRenderer={this.deviationRenderer}
        moveDeviationToPosition={this.props.moveDeviationToPosition}
      />
    );
  }

  deviationRenderer = (
    deviation: PapiDeviation,
    index,
    deviations: PapiDeviation[]
  ) => {
    return <ManageableDeviation index={index} deviation={deviation} />;
  };
}

export default enhance(
  CustomSetDeviationManager
) as any as React.ComponentClass<Props>;
